import { type Epic, combineEpics } from 'redux-observable';
import { filter, map } from 'rxjs';
import { overSome } from 'lodash/fp';
import {
  setSelectedDate,
  setSelectedSport,
  setSelectedCompetition,
} from '../actions';

const handleFilterChangeEpic: Epic = (action$) =>
  action$.pipe(
    filter(overSome([setSelectedDate.match, setSelectedSport.match])),
    map(() => setSelectedCompetition('')),
  );

export default combineEpics(handleFilterChangeEpic);
